enum BannerExtension {
  GOV = '.gov',
  MIL = '.mil',
}

export default BannerExtension;
